// import { ChevronDown } from 'lucide-vue-next';
// import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
export default {
    components: {
    // ChevronDown,
    },
    props: {
        modelValue: {
            required: true,
        },
        objectKey: String,
        objectLabel: String,
        options: Array,
        placeholder: {
            type: String,
            default: 'Select...',
        },
        label: {
            default: null,
            type: String
        }
    },
    emits: ['update:modelValue'],
    setup(props) {
        // destructuring props like this will remove reactivity form them
        // but we are fine with that
        const computedOptions = computed(() => {
            return props.options?.map(opt => {
                if (!props.objectKey)
                    return {
                        label: opt,
                        value: opt,
                    };
                if (!opt[props.objectKey]) {
                    throw new Error('Object is missing key');
                }
                return {
                    label: opt[props.objectLabel],
                    value: opt[props.objectKey],
                };
            });
        });
        return { computedOptions };
    },
};
